require('./helpers/bundle-manifest').register(JSON.parse("{\"brTCj\":\"index.ff863e95.js\",\"kvrLk\":\"icons.9801e6f1.svg\"}"));